import React from 'react';
import Select from 'react-select';
import DOG_BREEDS from '../../constants/dogBreeds';
import './MultiBreedSelect.css';

// Custom styles for react-select - Clean, Professional Design
const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '46px',
    borderRadius: '8px',
    border: state.isFocused ? '1px solid rgba(142, 187, 106, 0.4)' : '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(142, 187, 106, 0.1)' : 'none',
    backgroundColor: '#141414',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: 'rgba(142, 187, 106, 0.3)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '4px 12px',
    gap: '4px',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.55)',
    fontSize: '15px',
  }),
  input: (base) => ({
    ...base,
    color: '#e5e5e5',
    fontSize: '15px',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'rgba(142, 187, 106, 0.15)',
    borderRadius: '6px',
    border: '1px solid rgba(142, 187, 106, 0.3)',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#8ebb6a',
    fontSize: '13px',
    fontWeight: '500',
    padding: '3px 6px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#8ebb6a',
    borderRadius: '0 6px 6px 0',
    '&:hover': {
      backgroundColor: 'rgba(142, 187, 106, 0.25)',
      color: '#fff',
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backgroundColor: '#1e1e1e',
    overflow: 'hidden',
    zIndex: 999999999999,
  }),
  menuList: (base) => ({
    ...base,
    padding: '6px',
    maxHeight: '250px',
    backgroundColor: '#1e1e1e',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#4a7c3f'
      : state.isFocused
        ? 'rgba(142, 187, 106, 0.1)'
        : 'transparent',
    color: state.isSelected ? '#fff' : '#e5e5e5',
    borderRadius: '6px',
    padding: '10px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    '&:active': {
      backgroundColor: state.isSelected ? '#4a7c3f' : 'rgba(142, 187, 106, 0.15)',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? '#8ebb6a' : 'rgba(255, 255, 255, 0.3)',
    transition: 'all 0.2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    '&:hover': {
      color: '#8ebb6a',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.55)',
    '&:hover': {
      color: '#f07070',
    },
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '14px',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 999999999999,
  }),
};

const MultiBreedSelect = ({
  value,
  onChange,
  placeholder = 'Select breeds...',
  inputId,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'aria-required': ariaRequired,
  'aria-invalid': ariaInvalid,
}) => {
  return (
    <Select
      isMulti
      options={DOG_BREEDS}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={customStyles}
      classNamePrefix="breed-select"
      isSearchable={true}
      isClearable={true}
      closeMenuOnSelect={true}
      noOptionsMessage={() => 'No breeds found'}
      inputId={inputId}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      aria-required={ariaRequired}
      aria-invalid={ariaInvalid}
    />
  );
};

export default MultiBreedSelect;
